import type { MailboxInfo } from 'owa-client-types';
import { isUnifiedInboxMailboxInfo } from 'owa-client-types/lib/UnifiedInboxMailboxInfo';

/**
 * Returns the MailboxInfos that are associated with the unified inbox
 * @param mailboxInfo Specifies a unified inbox
 * @returns The MailboxInfos of all the mailboxes that are part of the unified inbox
 */
export function getMailboxInfosInUnifiedInbox(mailboxInfo: MailboxInfo): MailboxInfo[] {
    if (isUnifiedInboxMailboxInfo(mailboxInfo)) {
        return mailboxInfo.accountsMailboxInfos || []; // Return the accountsMailboxInfos or an empty array if undefined
    }

    throw new Error('MailboxInfo is not a unified inbox');
}
